import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_2 = {
  style: {"color":"red"},
  class: "mr-4"
}
const _hoisted_3 = {
  "no-gutters": "",
  class: "d-flex align-center"
}
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_5 = {
  key: 1,
  class: "d-flex align-center"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick", "data-cy"]
const _hoisted_8 = {
  class: "text-center",
  style: {"width":"64px"}
}
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "px-2" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 5,
  class: "ml-2"
}
const _hoisted_13 = {
  key: 6,
  class: "ml-2"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "pt-2" }
const _hoisted_24 = {
  key: 0,
  class: "text-center"
}
const _hoisted_25 = {
  key: 1,
  class: "text-center"
}
const _hoisted_26 = {
  key: 0,
  class: "body-1 text-center"
}
const _hoisted_27 = {
  key: 1,
  class: "body-1 text-center"
}
const _hoisted_28 = {
  key: 0,
  class: "text-center",
  style: {"z-index":"1"}
}
const _hoisted_29 = { class: "bottom-sheet" }
const _hoisted_30 = {
  class: "remote",
  style: {"pointer-events":"auto"}
}
const _hoisted_31 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_input = _resolveComponent("v-input")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_AuditCheckAlertButton = _resolveComponent("AuditCheckAlertButton")!
  const _component_AuditCheckOkButton = _resolveComponent("AuditCheckOkButton")!
  const _component_BankReconciliationDiscrepancyDialog = _resolveComponent("BankReconciliationDiscrepancyDialog")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_oss_filter_bar = _resolveComponent("oss-filter-bar")!
  const _component_TutorialButtonDialog = _resolveComponent("TutorialButtonDialog")!
  const _component_BankFlow = _resolveComponent("BankFlow")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn_ternary = _resolveComponent("v-btn-ternary")!
  const _component_AccountableAccountVue = _resolveComponent("AccountableAccountVue")!
  const _component_multiple_free_tagging = _resolveComponent("multiple-free-tagging")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_chip_tag = _resolveComponent("v-chip-tag")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_oss_card = _resolveComponent("oss-card")!
  const _component_ImportBankMain = _resolveComponent("ImportBankMain")!
  const _component_WithoutInvoice = _resolveComponent("WithoutInvoice")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_IOPBankTransactionDialog = _resolveComponent("IOPBankTransactionDialog")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_BankTransactionEdition = _resolveComponent("BankTransactionEdition")!
  const _component_AutoSales = _resolveComponent("AutoSales")!
  const _component_ThirdPartyCompany = _resolveComponent("ThirdPartyCompany")!
  const _component_CreateBTChatMessage = _resolveComponent("CreateBTChatMessage")!
  const _component_document = _resolveComponent("document")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_intersect = _resolveDirective("intersect")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: "",
    style: {"overflow":"hidden","height":"calc(100vh - 64px)"}
  }, {
    default: _withCtx(() => [
      (_ctx.isAuthorized)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!_ctx.auditCheck)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  "no-gutters": "",
                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pb-0 pt-3' : 'my-3 justify-center')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: _ctx.$vuetify.display.mobile ? '12' : '3'
                    }, {
                      default: _withCtx(() => [
                        (_ctx.account && _ctx.accounts && _ctx.accounts.length)
                          ? (_openBlock(), _createBlock(_component_v_menu, {
                              key: 0,
                              "offset-y": ""
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_input, _mergeProps({ class: "bg-primary-foreground rounded-xl v-field v-field--flat px-4 py-2" }, props, { "hide-details": "" }), {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createTextVNode(_toDisplayString(_ctx.formatBankAccount(_ctx.account)) + " ", 1),
                                      (
                                            _ctx.account &&
                                            _ctx.account.currentError &&
                                            _ctx.account.currentError.length > 0
                                        )
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, " - " + _toDisplayString(_ctx.account.currentError), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1040)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list, null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: index,
                                        onClick: ($event: any) => (_ctx.selectedAccount = item.id)
                                      }, {
                                        append: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_2, _toDisplayString(item.currentError), 1)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.formatBankAccount(item)), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["cols"]),
                    (_ctx.isAccountingUser && !_ctx.$vuetify.display.mobile)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "auto"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.showReconciliationDiscrepancyAlertButton)
                              ? (_openBlock(), _createBlock(_component_AuditCheckAlertButton, {
                                  key: 0,
                                  auditCheckType: "Bank",
                                  unreconciledBalancesAccountNames: _ctx.unreconciledBalancesAccountNames,
                                  onAuditCheckAlertButtonClicked: _ctx.onAuditCheckAlertButtonClick
                                }, null, 8, ["unreconciledBalancesAccountNames", "onAuditCheckAlertButtonClicked"]))
                              : _createCommentVNode("", true),
                            (_ctx.showReconciliationOkButton)
                              ? (_openBlock(), _createBlock(_component_AuditCheckOkButton, {
                                  key: 1,
                                  auditCheckType: "Bank",
                                  accountingPeriodId: _ctx.accountingPeriod?.id,
                                  companyId: _ctx.selectedCompany.id
                                }, null, 8, ["accountingPeriodId", "companyId"]))
                              : _createCommentVNode("", true),
                            (_ctx.showBankReconciliationDiscrepancyDialog)
                              ? (_openBlock(), _createBlock(_component_BankReconciliationDiscrepancyDialog, {
                                  key: 2,
                                  modelValue: _ctx.showBankReconciliationDiscrepancyDialog,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showBankReconciliationDiscrepancyDialog) = $event)),
                                  accountingPeriodId: _ctx.accountingPeriod?.id,
                                  companyId: _ctx.selectedCompany.id,
                                  width: "800px"
                                }, null, 8, ["modelValue", "accountingPeriodId", "companyId"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.$vuetify.display.mobile && _ctx.pagination.totalItems)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          cols: "2",
                          class: "pl-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              readonly: "",
                              "model-value": 
                            'Recettes : ' +
                            (_ctx.selected.length
                                ? _ctx.newCommonFormatCurrency(_ctx.selectedAmountDebit, undefined)
                                : _ctx.newCommonFormatCurrency(_ctx.amountDebit, undefined))
                        
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.$vuetify.display.mobile && _ctx.pagination.totalItems)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 2,
                          cols: "2",
                          class: "pl-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              readonly: "",
                              "model-value": 
                            'Dépenses : ' +
                            (_ctx.selected.length
                                ? _ctx.newCommonFormatCurrency(_ctx.selectedAmountCredit, undefined)
                                : _ctx.newCommonFormatCurrency(_ctx.amountCredit, undefined))
                        
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_spacer),
                    (_ctx.isAccountingUser && !_ctx.$vuetify.display.mobile)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 3,
                          cols: "2",
                          class: "pl-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn_primary, {
                              size: "large",
                              block: "",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reconciliateCompany())),
                              "data-cy": "bank-reconciliate"
                            }, {
                              default: _withCtx(() => _cache[76] || (_cache[76] = [
                                _createTextVNode(" Lettrage auto ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (
                        _ctx.isAccountingUser &&
                        _ctx.account &&
                        _ctx.account.id &&
                        _ctx.account.budgetInsightId &&
                        !_ctx.$vuetify.display.mobile
                    )
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 4,
                          cols: "2",
                          class: "pl-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn_primary, {
                              block: "",
                              size: "large",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateBankAccount()))
                            }, {
                              default: _withCtx(() => _cache[77] || (_cache[77] = [
                                _createTextVNode(" Synchroniser ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'py-0' : 'pb-2')
            }, {
              default: _withCtx(() => [
                (
                        _ctx.currentUser.profile.configuration.bankTransaction.import &&
                        !_ctx.$vuetify.display.mobile
                    )
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn_primary, {
                          block: "",
                          size: "large",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.importWizard = true)),
                          disabled: !!_ctx.auditCheck,
                          "data-cy": "bank-import"
                        }, {
                          default: _withCtx(() => _cache[78] || (_cache[78] = [
                            _createTextVNode(" Importer ")
                          ])),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_col, {
                  cols: _ctx.$vuetify.display.mobile ? '11' : '9',
                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pt-1' : '')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oss_filter_bar, {
                      mode: 'bankTransaction',
                      type: _ctx.amountType,
                      "onUpdate:type": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.amountType) = $event)),
                      text: _ctx.search,
                      "onUpdate:text": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.search) = $event)),
                      tags: _ctx.bankTransactionTags,
                      "onUpdate:tags": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bankTransactionTags) = $event)),
                      startDate: _ctx.beginDate,
                      "onUpdate:startDate": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.beginDate) = $event)),
                      endDate: _ctx.endDate,
                      "onUpdate:endDate": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.endDate) = $event)),
                      status: _ctx.reconciliationStatus,
                      "onUpdate:status": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.reconciliationStatus) = $event)),
                      minPrice: _ctx.minAmount,
                      "onUpdate:minPrice": _cache[10] || (_cache[10] = (minPrice) => (_ctx.minAmount = `${minPrice}`)),
                      maxPrice: _ctx.maxAmount,
                      "onUpdate:maxPrice": [
                        _cache[11] || (_cache[11] = ($event: any) => ((_ctx.maxAmount) = $event)),
                        _cache[12] || (_cache[12] = (maxPrice) => (_ctx.maxAmount = `${maxPrice}`))
                      ],
                      payBy: _ctx.payBy,
                      "onUpdate:payBy": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.payBy) = $event)),
                      limitMinPrice: _ctx.limitMinAmount,
                      limitMaxPrice: _ctx.limitMaxAmount,
                      "types-list": _ctx.amountTypes,
                      "status-list": 
                            _ctx.allReconciliationStatus.map((status) => {
                                return { value: status, text: _ctx.formatStatus(status) };
                            })
                        ,
                      payByList: _ctx.payByList,
                      companyId: _ctx.selectedCompany.id,
                      auditCheck: _ctx.auditCheck,
                      "onUpdate:auditCheck": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.auditCheck) = $event)),
                      auditChecks: _ctx.auditChecks,
                      displayGraph: _ctx.displayGraph,
                      "onUpdate:displayGraph": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.displayGraph) = $event)),
                      selectedAccount: _ctx.selectedAccount,
                      partitionTagId: _ctx.partitionTagId,
                      "onUpdate:partitionTagId": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.partitionTagId) = $event)),
                      "data-cy": "Bank-filter"
                    }, null, 8, ["type", "text", "tags", "startDate", "endDate", "status", "minPrice", "maxPrice", "payBy", "limitMinPrice", "limitMaxPrice", "types-list", "status-list", "payByList", "companyId", "auditCheck", "auditChecks", "displayGraph", "selectedAccount", "partitionTagId"])
                  ]),
                  _: 1
                }, 8, ["cols", "class"]),
                (!_ctx.$vuetify.display.mobile)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: "1",
                      class: "d-flex justify-end"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_TutorialButtonDialog, { starterComponents: 'Bank;' })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"]),
            _createElementVNode("div", null, [
              (_ctx.displayGraph)
                ? (_openBlock(), _createBlock(_component_BankFlow, {
                    key: 0,
                    companyId: _ctx.selectedCompany.id,
                    startDates: { startDate: _ctx.beginDate, endDate: _ctx.endDate },
                    onGraphDate: _cache[17] || (_cache[17] = ($event: any) => (_ctx.graphDate = $event)),
                    selectedAccount: _ctx.selectedAccount
                  }, null, 8, ["companyId", "startDates", "selectedAccount"]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.accounts.length && !_ctx.loading)
              ? (_openBlock(), _createBlock(_component_v_card, {
                  key: 1,
                  class: "default_card text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { "primary-title": "" }, {
                      default: _withCtx(() => _cache[79] || (_cache[79] = [
                        _createTextVNode(" Ajoutez un compte bancaire pour visualiser vos transactions ")
                      ])),
                      _: 1
                    }),
                    (_ctx.addBankAccountAvailable)
                      ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              onClick: _ctx.connectClicked,
                              loading: _ctx.connectLoading,
                              size: "small"
                            }, {
                              default: _withCtx(() => _cache[80] || (_cache[80] = [
                                _createTextVNode(" Ajoutez un compte bancaire ")
                              ])),
                              _: 1
                            }, 8, ["onClick", "loading"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.$vuetify.display.mobile)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 2,
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: _ctx.bankTransactionIdOpen ? 8 : 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oss_data_table, {
                          modelValue: _ctx.selected,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.selected) = $event)),
                          "show-select": true,
                          headers: _ctx.headers,
                          items: _ctx.items,
                          page: _ctx.pagination.page,
                          "onUpdate:page": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.pagination.page) = $event)),
                          "sort-by": _ctx.sortBy,
                          "onUpdate:sortBy": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.sortBy) = $event)),
                          "sort-desc": _ctx.pagination.descending,
                          "onUpdate:sortDesc": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.pagination.descending) = $event)),
                          "items-length": _ctx.pagination.totalItems,
                          "items-per-page": _ctx.pagination.rowsPerPage,
                          "onUpdate:itemsPerPage": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.pagination.rowsPerPage) = $event)),
                          "items-per-page-options": [5, 10, 25],
                          loading: _ctx.loading,
                          "onUpdate:loading": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.loading) = $event)),
                          class: "table",
                          "hide-default-footer": "",
                          "fixed-header": "",
                          "return-object": "",
                          height: "71vh",
                          style: {"border-collapse":"collapse"},
                          "data-cy": "bank-table"
                        }, {
                          header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              (_ctx.isAccountingUser || _ctx.isAccountingClientOfIOP)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_ctx.isAccountingUser)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createVNode(_component_v_btn_ternary, {
                                            disabled: _ctx.disabledWithoutInvoice,
                                            onClick: _cache[18] || (_cache[18] = ($event: any) => (
                                                _ctx.showCreateBankTransactionMessageDialog =
                                                    !_ctx.showCreateBankTransactionMessageDialog
                                            )),
                                            icon: "$fa-comments"
                                          }, null, 8, ["disabled"]),
                                          _createVNode(_component_v_btn_ternary, {
                                            onClick: _cache[19] || (_cache[19] = ($event: any) => {
                                                _ctx.companyType = 'SUPPLIER';
                                                _ctx.thirdPartyDialog = !_ctx.thirdPartyDialog;
                                            }),
                                            class: "ml-2",
                                            disabled: _ctx.disabledThirdPartyCompany()
                                          }, {
                                            default: _withCtx(() => _cache[81] || (_cache[81] = [
                                              _createTextVNode(" Fournisseur ")
                                            ])),
                                            _: 1
                                          }, 8, ["disabled"]),
                                          _createVNode(_component_v_btn_ternary, {
                                            onClick: _cache[20] || (_cache[20] = ($event: any) => {
                                                _ctx.companyType = 'CUSTOMER';
                                                _ctx.thirdPartyDialog = !_ctx.thirdPartyDialog;
                                            }),
                                            class: "ml-2",
                                            disabled: _ctx.disabledThirdPartyCompany()
                                          }, {
                                            default: _withCtx(() => _cache[82] || (_cache[82] = [
                                              _createTextVNode(" Client ")
                                            ])),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    (_openBlock(), _createBlock(_component_AccountableAccountVue, {
                                      title: _ctx.subAccountableAccountTitle,
                                      showLabel: _ctx.subDefaultParams,
                                      showValidation: false,
                                      companyId: _ctx.selectedCompany.id,
                                      inAccountableAccountType: _ctx.subInAccountableAccountType,
                                      embeddedInput: true,
                                      editAccountableAccount: _ctx.subDefaultParams,
                                      inAccountableAccountNames: _ctx.subSelectedAccountableAccounts,
                                      defineThirdParty: true,
                                      activateFreeTag: _ctx.subDefaultParams,
                                      bankTransactionId: 
                                            _ctx.selected.length === 1 ? _ctx.selected[0].id : ''
                                        ,
                                      publishedAccounts: !_ctx.subDefaultParams,
                                      onClose: _ctx.closeAccountableAccount,
                                      onSelectAccountableAccount: _cache[25] || (_cache[25] = ($event: any) => (_ctx.setAccountableAccount($event))),
                                      key: _ctx.refreshKey
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        (_ctx.isAccountingUser)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                              _createVNode(_component_v_btn_ternary, _mergeProps({
                                                class: "ml-2",
                                                disabled: _ctx.disabledThirdPartyCompany(),
                                                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.socialAccountableAccount()))
                                              }, props), {
                                                default: _withCtx(() => _cache[83] || (_cache[83] = [
                                                  _createTextVNode(" Social ")
                                                ])),
                                                _: 2
                                              }, 1040, ["disabled"]),
                                              _createVNode(_component_v_btn_ternary, _mergeProps({
                                                class: "ml-2",
                                                disabled: _ctx.disabledThirdPartyCompany(),
                                                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.stateAccountableAccount()))
                                              }, props), {
                                                default: _withCtx(() => _cache[84] || (_cache[84] = [
                                                  _createTextVNode(" Etat ")
                                                ])),
                                                _: 2
                                              }, 1040, ["disabled"]),
                                              _createVNode(_component_v_btn_ternary, _mergeProps({
                                                class: "ml-2",
                                                disabled: _ctx.disabledThirdPartyCompany(),
                                                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.miscelleanousAccountableAccount()))
                                              }, props), {
                                                default: _withCtx(() => _cache[85] || (_cache[85] = [
                                                  _createTextVNode(" Autres ")
                                                ])),
                                                _: 2
                                              }, 1040, ["disabled"])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.isAccountingClientOfIOP)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                              _createVNode(_component_v_btn_ternary, _mergeProps({
                                                ref: "asignButton",
                                                class: "ml-2",
                                                disabled: _ctx.isIopAccountableAccountDisabled,
                                                onClick: _cache[24] || (_cache[24] = ($event: any) => (
                                                        _ctx.incomingOutgoingPaymentAccountableAccount()
                                                    ))
                                              }, props), {
                                                default: _withCtx(() => _cache[86] || (_cache[86] = [
                                                  _createTextVNode(" Affecter ")
                                                ])),
                                                _: 2
                                              }, 1040, ["disabled"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }, 8, ["title", "showLabel", "companyId", "inAccountableAccountType", "editAccountableAccount", "inAccountableAccountNames", "activateFreeTag", "bankTransactionId", "publishedAccounts", "onClose"])),
                                    (_ctx.isAccountingUser)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          (_ctx.showZTillReconciliation)
                                            ? (_openBlock(), _createBlock(_component_v_btn_ternary, {
                                                key: 0,
                                                class: "ml-2",
                                                disabled: _ctx.disabledZTillReconciliation,
                                                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showZTillDialog = true))
                                              }, {
                                                default: _withCtx(() => _cache[87] || (_cache[87] = [
                                                  _createTextVNode(" Z de caisse ")
                                                ])),
                                                _: 1
                                              }, 8, ["disabled"]))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_btn_ternary, {
                                            class: "ml-2",
                                            disabled: 
                                                _ctx.disabledValidateAutoAllocationAndReconciliation
                                            ,
                                            onClick: _ctx.validateAutoAllocationAndReconciliation
                                          }, {
                                            default: _withCtx(() => _cache[88] || (_cache[88] = [
                                              _createTextVNode(" Valider ")
                                            ])),
                                            _: 1
                                          }, 8, ["disabled", "onClick"]),
                                          (!_ctx.declareSalesInvoices)
                                            ? (_openBlock(), _createBlock(_component_v_btn_ternary, {
                                                key: 1,
                                                class: "ml-2",
                                                disabled: _ctx.disabledAutoSalesReconciliation,
                                                onClick: _cache[27] || (_cache[27] = ($event: any) => (
                                                _ctx.autoSalesReconciliationDialog =
                                                    !_ctx.autoSalesReconciliationDialog
                                            )),
                                                loading: _ctx.autoSalesReconciliationLoading
                                              }, {
                                                default: _withCtx(() => _cache[89] || (_cache[89] = [
                                                  _createTextVNode(" Encaissement ")
                                                ])),
                                                _: 1
                                              }, 8, ["disabled", "loading"]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true),
                              _createVNode(_component_multiple_free_tagging, {
                                company: _ctx.selectedCompany,
                                "company-tags": _ctx.allCompanyTags,
                                "selected-bank-transactions": _ctx.selected,
                                onSelectedTags: _ctx.onMultiTagguingApplied
                              }, null, 8, ["company", "company-tags", "selected-bank-transactions", "onSelectedTags"]),
                              _createVNode(_component_v_menu, { "offset-y": "" }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props), null, 16)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list, null, {
                                    default: _withCtx(() => [
                                      (_ctx.isAccountingUser)
                                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: 0,
                                            disabled: _ctx.disabledWithoutInvoice,
                                            onClick: _ctx.onWithoutInvoiceClick
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => _cache[90] || (_cache[90] = [
                                                  _createTextVNode(" Justificatif manquant ")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["disabled", "onClick"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.showTransactionType && _ctx.isAccountingUser)
                                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: 1,
                                            disabled: _ctx.disabledTransactionType,
                                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.openTransactionTypeDialog(null)))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => _cache[91] || (_cache[91] = [
                                                  _createTextVNode(" Type de transaction ")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.isAccountingUser)
                                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: 2,
                                            disabled: 
                                                !_ctx.account ||
                                                !_ctx.account.id ||
                                                _ctx.account.id === 'ALL' ||
                                                !_ctx.selected.length
                                            ,
                                            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.analyseBankTransactionWordings()))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => _cache[92] || (_cache[92] = [
                                                  _createTextVNode(" Analyser les libellés ")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.isAccountingUser)
                                        ? (_openBlock(), _createBlock(_component_v_divider, { key: 3 }))
                                        : _createCommentVNode("", true),
                                      (_ctx.isAccountingUser)
                                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: 4,
                                            disabled: !_ctx.showDeallocation,
                                            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.openDeallocateDialog())),
                                            color: _ctx.showDeallocation ? '' : 'error'
                                          }, {
                                            append: _withCtx(() => [
                                              _createVNode(_component_v_icon, { size: "small" }, {
                                                default: _withCtx(() => _cache[94] || (_cache[94] = [
                                                  _createTextVNode("$delete")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => _cache[93] || (_cache[93] = [
                                                  _createTextVNode(" Retirer l'affectation ")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["disabled", "color"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_list_item, {
                                        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showTag = !_ctx.showTag))
                                      }, {
                                        append: _withCtx(() => [
                                          _createVNode(_component_v_icon, { size: "small" }, {
                                            default: _withCtx(() => _cache[95] || (_cache[95] = [
                                              _createTextVNode("$oss-eye")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.showTag
                                                    ? "Cacher les étiquettes"
                                                    : "Afficher les étiquettes"), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_list_item, {
                                        disabled: _ctx.disabledDeleteBT,
                                        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.showDeleteBankTransactionsDialog = true)),
                                        color: _ctx.disabledDeleteBT ? '' : 'error'
                                      }, {
                                        append: _withCtx(() => [
                                          _createVNode(_component_v_icon, { size: "small" }, {
                                            default: _withCtx(() => _cache[97] || (_cache[97] = [
                                              _createTextVNode(" $delete ")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => _cache[96] || (_cache[96] = [
                                              _createTextVNode(" Supprimer ")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "color"]),
                                      (_ctx.disabledRestoreBT)
                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                            key: 5,
                                            top: ""
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createElementVNode("div", _mergeProps({ style: {"height":"fit-content"} }, props), [
                                                _createVNode(_component_v_list_item, { disabled: "" }, {
                                                  append: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { size: "small" }, {
                                                      default: _withCtx(() => _cache[99] || (_cache[99] = [
                                                        _createTextVNode(" $oss-edit ")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                      default: _withCtx(() => _cache[98] || (_cache[98] = [
                                                        _createTextVNode(" Restaurer ")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ], 16)
                                            ]),
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canBeRestoredTooltipMessages, (line) => {
                                                return (_openBlock(), _createElementBlock("h4", null, _toDisplayString(line), 1))
                                              }), 256))
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: 6,
                                            onClick: _ctx.restoreBankTransactions
                                          }, {
                                            append: _withCtx(() => [
                                              _createVNode(_component_v_icon, { size: "small" }, {
                                                default: _withCtx(() => _cache[101] || (_cache[101] = [
                                                  _createTextVNode(" $oss-edit ")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => _cache[100] || (_cache[100] = [
                                                  _createTextVNode(" Restaurer ")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"])),
                                      (_ctx.disabledRestoreBT)
                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                            key: 7,
                                            top: ""
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createElementVNode("div", _mergeProps({ style: {"height":"fit-content"} }, props), [
                                                _createVNode(_component_v_list_item, { disabled: "" }, {
                                                  append: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { size: "small" }, {
                                                      default: _withCtx(() => _cache[103] || (_cache[103] = [
                                                        _createTextVNode(" $delete ")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                      default: _withCtx(() => _cache[102] || (_cache[102] = [
                                                        _createTextVNode(" Supprimer définitivement ")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ], 16)
                                            ]),
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canBeRestoredTooltipMessages, (line) => {
                                                return (_openBlock(), _createElementBlock("h4", null, _toDisplayString(line), 1))
                                              }), 256))
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: 8,
                                            color: "red",
                                            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.dialogDeletePermanentlySelectedBTs = true))
                                          }, {
                                            append: _withCtx(() => [
                                              _createVNode(_component_v_icon, { size: "small" }, {
                                                default: _withCtx(() => _cache[105] || (_cache[105] = [
                                                  _createTextVNode(" $delete ")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => _cache[104] || (_cache[104] = [
                                                  _createTextVNode(" Supprimer définitivement ")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          "no-data": _withCtx(() => [
                            (_ctx.account && !_ctx.account.initialSyncDone)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Synchronisation en cours, les opérations apparaîtront bientôt "))
                              : _createCommentVNode("", true)
                          ]),
                          item: _withCtx((props) => [
                            _createElementVNode("tr", {
                              onClick: _withModifiers(($event: any) => (_ctx.onItemClick(props.item)), ["stop"]),
                              class: "cursor-pointer",
                              style: _normalizeStyle(
                                    props.item.id === _ctx.bankTransactionIdOpen
                                        ? 'box-shadow: inset 0px 0px 0px 2px #F9B12A'
                                        : ''
                                ),
                              "data-cy": 'Bank_table_' + props.index
                            }, [
                              _createElementVNode("td", _hoisted_8, [
                                _createVNode(_component_v_checkbox, {
                                  onClick: _cache[34] || (_cache[34] = _withModifiers(() => {}, ["stop"])),
                                  "onUpdate:modelValue": ($event: any) => (props.select()),
                                  ripple: false,
                                  "hide-details": "",
                                  "model-value": props.isSelected
                                }, null, 8, ["onUpdate:modelValue", "model-value"])
                              ]),
                              _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.formatDateForUI(props.item.dateDebit)), 1),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: 12,
                                      class: "body-1"
                                    }, {
                                      default: _withCtx(() => [
                                        (props.item.accountingLineTags)
                                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.item
                                                        .accountingLineTags, (tag, index) => {
                                              return (_openBlock(), _createBlock(_component_v_chip_tag, {
                                                ripple: false,
                                                key: index,
                                                class: "text mr-1"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", {
                                                    style: _normalizeStyle(
                                                            'color:' +
                                                            props.item.labelTextColor +
                                                            ';'
                                                        )
                                                  }, _toDisplayString(tag.name), 5)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", null, _toDisplayString(props.item.wordingDisplay ||
                                                props.item.wordingOriginal), 1),
                                        (
                                                    props.item.uniqueExport &&
                                                    props.item.uniqueExport.id
                                                )
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 1,
                                              color: "secondary",
                                              size: "small",
                                              location: "end"
                                            }, {
                                              default: _withCtx(() => _cache[106] || (_cache[106] = [
                                                _createTextVNode(" $oss-already-downloaded ")
                                              ])),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "body-2 d-flex align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.account && _ctx.account.id === 'ALL')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createVNode(_component_v_icon, { size: "small" }, {
                                                default: _withCtx(() => _cache[107] || (_cache[107] = [
                                                  _createTextVNode(" $fa-university ")
                                                ])),
                                                _: 1
                                              }),
                                              _createElementVNode("span", _hoisted_10, _toDisplayString(props.item.account.name), 1)
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        (props.item.account.type === 'CASH_BOX')
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 1,
                                              size: "small",
                                              left: "",
                                              onClick: _withModifiers(($event: any) => (_ctx.openTransactionTypeDialog(props.item)), ["stop"])
                                            }, {
                                              default: _withCtx(() => _cache[108] || (_cache[108] = [
                                                _createTextVNode(" $fa-cash-register ")
                                              ])),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : (_ctx.getTransactionTypeIcon(props.item))
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 2,
                                                size: "small",
                                                left: "",
                                                onClick: _withModifiers(($event: any) => (_ctx.openTransactionTypeDialog(props.item)), ["stop"])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.getTransactionTypeIcon(props.item)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : (_openBlock(), _createBlock(_component_v_avatar, {
                                                key: 3,
                                                onClick: _withModifiers(($event: any) => (_ctx.openTransactionTypeDialog(props.item)), ["stop"]),
                                                color: "grey",
                                                class: "subheading white--text mr-1",
                                                size: "18"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.getTransactionTypeBigram(props.item)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"])),
                                        _createElementVNode("span", {
                                          onClick: _withModifiers(($event: any) => (_ctx.openTransactionTypeDialog(props.item)), ["stop"])
                                        }, _toDisplayString(_ctx.getTransactionTypeText(props.item)), 9, _hoisted_11),
                                        (props.item.thirdPartyCompany)
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 4,
                                              size: "small",
                                              left: "",
                                              right: ""
                                            }, {
                                              default: _withCtx(() => _cache[109] || (_cache[109] = [
                                                _createTextVNode("$bookmark")
                                              ])),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (props.item.allSuppliers)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Fournisseur :"))
                                          : (props.item.allCustomers)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Client : "))
                                            : _createCommentVNode("", true),
                                        (props.item.thirdPartyCompanies)
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 7,
                                              style: _normalizeStyle(
                                                    props.item.containtsThirdPartyCompanySuggestion
                                                        ? 'color:magic;'
                                                        : ''
                                                ),
                                              onClick: _withModifiers(($event: any) => (
                                                    _ctx.openAccountableAccountWithSuggestion(props.item)
                                                ), ["stop"]),
                                              class: "ml-2"
                                            }, _toDisplayString(props.item.thirdPartyCompanies), 13, _hoisted_14))
                                          : _createCommentVNode("", true),
                                        (
                                                    props.item.containtsThirdPartyCompanySuggestion
                                                )
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 8,
                                              size: "x-small",
                                              left: "",
                                              right: "",
                                              color: "ternary",
                                              class: "ml-2",
                                              onClick: _withModifiers(($event: any) => (
                                                    _ctx.openAccountableAccountWithSuggestion(props.item)
                                                ), ["stop"])
                                            }, {
                                              default: _withCtx(() => _cache[110] || (_cache[110] = [
                                                _createTextVNode("$fa-magic")
                                              ])),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (props.item.allUsers)
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 9,
                                              size: "x-small",
                                              left: "",
                                              right: ""
                                            }, {
                                              default: _withCtx(() => _cache[111] || (_cache[111] = [
                                                _createTextVNode("$fa-user")
                                              ])),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (props.item.allUsers)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                                              _createTextVNode(" Collaborateur : " + _toDisplayString(props.item.users), 1)
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", {
                                          style: _normalizeStyle(
                                                    props.item.containtsThirdPartyCompanySuggestion
                                                        ? 'color:magic;'
                                                        : ''
                                                ),
                                          onClick: _withModifiers(($event: any) => (
                                                    _ctx.openAccountableAccountWithSuggestion(props.item)
                                                ), ["stop"])
                                        }, _toDisplayString(props.item.userSuggestion), 13, _hoisted_15),
                                        (props.item.containsUserSuggestion)
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 11,
                                              size: "x-small",
                                              left: "",
                                              right: "",
                                              color: "ternary",
                                              class: "ml-2",
                                              onClick: _withModifiers(($event: any) => (
                                                    _ctx.openAccountableAccountWithSuggestion(props.item)
                                                ), ["stop"])
                                            }, {
                                              default: _withCtx(() => _cache[112] || (_cache[112] = [
                                                _createTextVNode("$fa-magic")
                                              ])),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "pb-1"
                                    }, {
                                      default: _withCtx(() => [
                                        (
                                                    _ctx.showTag &&
                                                    _ctx.currentUser.profile.configuration.tag.write
                                                )
                                          ? (_openBlock(), _createBlock(_component_FreeTag, {
                                              company: _ctx.selectedCompany,
                                              companyTags: _ctx.allCompanyTags,
                                              bankTransaction: props.item,
                                              onFocus: _ctx.onFreeTagFocus,
                                              onBlur: _ctx.onFreeTagBlur,
                                              key: props.item.id
                                            }, null, 8, ["company", "companyTags", "bankTransaction", "onFocus", "onBlur"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("td", _hoisted_16, [
                                _createVNode(_component_v_btn_icon, {
                                  icon: "$oss-edit",
                                  onClick: _withModifiers(($event: any) => (_ctx.openEditWording(props.item)), ["stop"]),
                                  "data-cy": 'Bank_BT_Dialog_' + props.index,
                                  size: "small"
                                }, null, 8, ["onClick", "data-cy"])
                              ]),
                              _createElementVNode("td", {
                                class: "text-right",
                                style: _normalizeStyle(props.item.amount < 0 ? 'color:red;' : '')
                              }, _toDisplayString(_ctx.newCommonFormatCurrency(props.item.amount, undefined)), 5),
                              (_ctx.isAccountingUser && props.item.status === 'DELETED')
                                ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                                    _createVNode(_component_v_chip, {
                                      class: "px-2",
                                      label: "",
                                      variant: "outlined",
                                      color: "red",
                                      size: "x-small"
                                    }, {
                                      default: _withCtx(() => _cache[113] || (_cache[113] = [
                                        _createTextVNode(" Supprimé ")
                                      ])),
                                      _: 1
                                    })
                                  ]))
                                : (
                                        _ctx.isAccountingUser &&
                                        props.item.reconciliationStatus &&
                                        props.item.reconciliationStatus.accountableAccounts.length
                                    )
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 1,
                                      onClick: _withModifiers(($event: any) => (_ctx.onAccountableAccountClick(props.item)), ["stop"])
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item
                                            .reconciliationStatus.accountableAccounts, (accountableAccount, index) => {
                                        return _withDirectives((_openBlock(), _createBlock(_component_v_chip, {
                                          key: index,
                                          class: "px-2",
                                          label: "",
                                          variant: "outlined",
                                          color: 
                                            !accountableAccount.name.startsWith('471000') &&
                                            !accountableAccount.name.startsWith('XXXX')
                                                ? 'green'
                                                : 'red'
                                        ,
                                          size: "x-small"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(accountableAccount.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["color"])), [
                                          [_directive_tooltip, accountableAccount.description]
                                        ])
                                      }), 128)),
                                      (
                                            !props.item.reconciliationStatus.accountableAccounts
                                                .length
                                        )
                                        ? _withDirectives((_openBlock(), _createBlock(_component_v_chip, {
                                            key: 0,
                                            class: "px-2",
                                            label: "",
                                            variant: "outlined",
                                            color: 'red',
                                            size: "x-small"
                                          }, {
                                            default: _withCtx(() => _cache[114] || (_cache[114] = [
                                              _createTextVNode(_toDisplayString(471000))
                                            ])),
                                            _: 1
                                          })), [
                                            [_directive_tooltip, 'Inconnu']
                                          ])
                                        : _createCommentVNode("", true)
                                    ], 8, _hoisted_18))
                                  : (
                                        _ctx.isAccountingUser &&
                                        props.item.reconciliationStatus.allocationSuggestion
                                    )
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                                        _withDirectives((_openBlock(), _createBlock(_component_v_chip, {
                                          class: "px-2",
                                          label: "",
                                          variant: "outlined",
                                          color: "magic",
                                          onClick: _withModifiers(($event: any) => (
                                            _ctx.openAccountableAccountWithSuggestion(props.item)
                                        ), ["stop"]),
                                          size: "x-small"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(props.item.reconciliationStatus.allocationSuggestion
                                                .accountableAccount.name) + " ", 1),
                                            _createVNode(_component_v_icon, {
                                              class: "ml-1",
                                              size: "x-small"
                                            }, {
                                              default: _withCtx(() => _cache[115] || (_cache[115] = [
                                                _createTextVNode("$fa-magic")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])), [
                                          [_directive_tooltip, props.item.fullSuggestionDescription]
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("td", {
                                        key: 3,
                                        class: "text-center",
                                        onClick: _withModifiers(($event: any) => (_ctx.onAccountableAccountClick(props.item)), ["stop"])
                                      }, [
                                        (
                                            props.item.statusIndice &&
                                            props.item.statusIndice === 'INFORMATION_REQUEST' &&
                                            !_ctx.isAccountingUser
                                        )
                                          ? (_openBlock(), _createBlock(_component_v_chip, {
                                              key: 0,
                                              class: _normalizeClass(["px-2", {
                                            hasDocumentOrValidatedStatus:
                                                props.item.reconciliation?.documents?.filter(
                                                    (doc) => typeof doc.original !== 'undefined',
                                                ).length ||
                                                props.item.linkedDocuments?.filter(
                                                    (doc) => doc.status === 'VALIDATED',
                                                ).length,
                                        }]),
                                              variant: "outlined",
                                              label: "",
                                              size: "x-small"
                                            }, {
                                              default: _withCtx(() => _cache[116] || (_cache[116] = [
                                                _createTextVNode(" Demande d'information ")
                                              ])),
                                              _: 2
                                            }, 1032, ["class"]))
                                          : (props.item.toJustify)
                                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                                key: 1,
                                                class: "px-2",
                                                variant: "outlined",
                                                label: "",
                                                size: "x-small"
                                              }, {
                                                default: _withCtx(() => _cache[117] || (_cache[117] = [
                                                  _createTextVNode(" A justifier ")
                                                ])),
                                                _: 1
                                              }))
                                            : (
                                            !props.item.reconciliationStatus.category &&
                                            !props.item.allocation
                                        )
                                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                                  key: 2,
                                                  class: "px-2",
                                                  variant: "outlined",
                                                  color: "red",
                                                  label: "",
                                                  size: "x-small"
                                                }, {
                                                  default: _withCtx(() => _cache[118] || (_cache[118] = [
                                                    _createTextVNode(" A affecter ")
                                                  ])),
                                                  _: 1
                                                }))
                                              : (_openBlock(), _createBlock(_component_v_chip, {
                                                  key: 3,
                                                  class: "px-2",
                                                  variant: "outlined",
                                                  color: "secondary",
                                                  label: "",
                                                  size: "x-small"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(props.item.reconciliationStatus.category ||
                                            props.item.allocation), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                      ], 8, _hoisted_20)),
                              (_ctx.showStatus)
                                ? (_openBlock(), _createElementBlock("td", {
                                    key: 4,
                                    class: "pr-2 text-center",
                                    onClick: _withModifiers(($event: any) => (_ctx.onReconciliationClick(props.item)), ["stop"])
                                  }, [
                                    (props.item.status !== 'DELETED')
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: _ctx.showBncAssignDocumentDialog.toString(),
                                          location: "start"
                                        }, {
                                          activator: _withCtx(({ props: ttProps }) => [
                                            _createVNode(_component_v_btn_icon, _mergeProps({
                                              icon: _ctx.reconciliationIcon(props.item)
                                            }, ttProps, {
                                              color: _ctx.reconciliationColor(props.item),
                                              size: "small"
                                            }), null, 16, ["icon", "color"])
                                          ]),
                                          default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.reconciliationTooltip(props.item)), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_21))
                                : _createCommentVNode("", true),
                              (_ctx.showStatus && !_ctx.isIncomingOutgoingPayment)
                                ? (_openBlock(), _createElementBlock("td", {
                                    key: 5,
                                    class: "pr-2 text-center",
                                    onClick: _withModifiers(($event: any) => (_ctx.onLinkedDocumentClick(props.item)), ["stop"])
                                  }, [
                                    (props.item.status !== 'DELETED')
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          location: "start"
                                        }, {
                                          activator: _withCtx(({ props: ttProps }) => [
                                            _createVNode(_component_v_btn_icon, _mergeProps({
                                              icon: _ctx.linkedDocumentIcon(props.item)
                                            }, ttProps, {
                                              color: _ctx.linkedDocumentColor(props.item),
                                              size: "small"
                                            }), null, 16, ["icon", "color"])
                                          ]),
                                          default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.linkedDocumentTooltip(props.item)), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_22))
                                : _createCommentVNode("", true)
                            ], 12, _hoisted_7)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "headers", "items", "page", "sort-by", "sort-desc", "items-length", "items-per-page", "loading"])
                      ]),
                      _: 1
                    }, 8, ["cols"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_row, {
                  key: 3,
                  class: "d-flex justify-center",
                  style: {"max-height":"calc(100vh - 226px)","overflow-y":"auto"},
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                      return (_openBlock(), _createBlock(_component_v_col, {
                        cols: "12",
                        class: "py-1",
                        key: index
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            elevation: "0",
                            class: "pa-2",
                            style: {"border-radius":"8px"},
                            onClick: ($event: any) => (_ctx.onItemClick(item))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                style: {"flex-wrap":"nowrap"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    style: {"min-width":"100px","max-width":"100%","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"},
                                    class: "flex-grow-1 flex-shrink-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.wordingDisplay || item.wordingOriginal), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    style: {"min-width":"100px","max-width":"100%"},
                                    class: "flex-grow-0 flex-shrink-1 d-flex justify-end"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                                            item?.amount > 0
                                                ? 'font-weight-bold primary--text'
                                                : 'text-red font-weight-bold'
                                        )
                                      }, _toDisplayString(_ctx.newCommonFormatCurrency(item.amount, undefined)), 3)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                style: {"flex-wrap":"nowrap"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    style: {"min-width":"100px","max-width":"100%","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"},
                                    class: "flex-grow-0 flex-shrink-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "secondary",
                                        size: "small",
                                        location: "start"
                                      }, {
                                        default: _withCtx(() => _cache[119] || (_cache[119] = [
                                          _createTextVNode("$oss-calendar")
                                        ])),
                                        _: 1
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.formatDateMobile(item.date)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    class: _normalizeClass(
                                        'flex-grow-1 flex-shrink-1 d-flex justify-end align-center ' +
                                        'text-' +
                                        _ctx.progressCircularColor(item.statusIndice)
                                    )
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_badge, {
                                        dot: "",
                                        inline: "",
                                        color: _ctx.progressCircularColor(item.statusIndice),
                                        class: "mr-1",
                                        floating: ""
                                      }, null, 8, ["color"]),
                                      _createTextVNode(" " + _toDisplayString(_ctx.stateTooltip(item)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    (
                            _ctx.items && _ctx.items.length && _ctx.items.length - _ctx.nbrDates < _ctx.pagination.totalItems
                        )
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "12",
                          class: "pa-0 d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives((_openBlock(), _createBlock(_component_oss_card, { skeleton: true }, {
                              left: _withCtx(() => _cache[120] || (_cache[120] = [])),
                              _: 1
                            })), [
                              [_directive_intersect, _ctx.onIntersectNext]
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })),
            (_ctx.importWizard)
              ? (_openBlock(), _createBlock(_component_ImportBankMain, {
                  key: 4,
                  modelValue: _ctx.importWizard,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.importWizard) = $event)),
                  onClose: _cache[42] || (_cache[42] = ($event: any) => (_ctx.importWizard = false)),
                  selectedAccountId: _ctx.selectedAccount,
                  onBankTransactionImported: _cache[43] || (_cache[43] = ($event: any) => (_ctx.refresh()))
                }, null, 8, ["modelValue", "selectedAccountId"]))
              : _createCommentVNode("", true),
            (_ctx.showWithoutInvoiceDialog)
              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                  key: 5,
                  modelValue: _ctx.showWithoutInvoiceDialog,
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.showWithoutInvoiceDialog) = $event)),
                  title: 'Sans facture',
                  actions: _ctx.withoutInvoiceActions,
                  width: "800px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_WithoutInvoice, {
                      companyId: _ctx.selectedCompany.id,
                      bts: _ctx.withoutInvoiceBTS,
                      actions: _ctx.withoutInvoiceActions,
                      onAdded: _cache[44] || (_cache[44] = ($event: any) => {
                        _ctx.showWithoutInvoiceDialog = false;
                        _ctx.refresh();
                    })
                    }, null, 8, ["companyId", "bts", "actions"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "actions"]))
              : _createCommentVNode("", true),
            (_ctx.showBncAssignDocumentDialog)
              ? (_openBlock(), _createBlock(_component_IOPBankTransactionDialog, {
                  key: 6,
                  modelValue: _ctx.showBncAssignDocumentDialog,
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.showBncAssignDocumentDialog) = $event)),
                  selectedCompany: _ctx.selectedCompany,
                  selectedBankTransaction: _ctx.selectedBankTransaction,
                  onBankTransactionChanged: _cache[47] || (_cache[47] = ($event: any) => {
                    _ctx.refresh();
                    _ctx.showBncAssignDocumentDialog = false;
                })
                }, null, 8, ["modelValue", "selectedCompany", "selectedBankTransaction"]))
              : _createCommentVNode("", true),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.showZTillDialog,
              "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.showZTillDialog) = $event)),
              title: "Affectation à un Z de caisse",
              validTitle: "Oui, je suis sûr(e)",
              onValid: _cache[49] || (_cache[49] = ($event: any) => (_ctx.executeZTillReconciliation())),
              width: "800px"
            }, {
              default: _withCtx(() => _cache[121] || (_cache[121] = [
                _createElementVNode("span", { class: "body-1 text-center" }, "Êtes-vous sûr(e) de vouloir affecter les mouvements bancaires à un z de caisse ?", -1)
              ])),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.showDeallocateDialog,
              "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.showDeallocateDialog) = $event)),
              title: "Retirer le ou les affectation(s) des comptes comptables",
              validTitle: "Retirer",
              loading: _ctx.deallocateReconciliationLoading,
              onValid: _cache[52] || (_cache[52] = ($event: any) => (_ctx.deallocateBankTransactions())),
              width: "800px"
            }, {
              default: _withCtx(() => [
                (_ctx.showDeallocationChoice)
                  ? (_openBlock(), _createBlock(_component_v_radio_group, {
                      key: 0,
                      modelValue: _ctx.deallocationChoice,
                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.deallocationChoice) = $event)),
                      column: "",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _cache[122] || (_cache[122] = _createElementVNode("div", { class: "body-1" }, "Retirer le ou les compte(s) comptable(s) de ?", -1)),
                        _createVNode(_component_v_radio, {
                          label: "la sélection",
                          value: "SELECTION"
                        }),
                        _createVNode(_component_v_radio, {
                          label: 'des ' + _ctx.pagination.totalItems + ' mouvements de la recherche',
                          value: "ALL"
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_23, _toDisplayString((_ctx.deallocationChoice === "SELECTION"
                            ? _ctx.enableDeallocationSelection
                            : _ctx.pagination.totalItems) + " mouvement(s) bancaire(s) impacté(s)"), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "loading"]),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.showDeleteBankTransactionsDialog,
              "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.showDeleteBankTransactionsDialog) = $event)),
              title: "Suppression",
              validTitle: "Oui, je suis sûr(e)",
              "valid-class": "error",
              onValid: _cache[54] || (_cache[54] = ($event: any) => (_ctx.deleteBankTransactions())),
              width: "800px"
            }, {
              default: _withCtx(() => [
                (!_ctx.stepData || !_ctx.stepData.action)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_24, " Êtes-vous sûr(e) de vouloir supprimer les mouvements bancaires ? "))
                  : _createCommentVNode("", true),
                (_ctx.stepData && !!_ctx.stepData.action)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_25, " Suppression en cours "))
                  : _createCommentVNode("", true),
                (_ctx.stepData && !!_ctx.stepData.action)
                  ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                      key: 2,
                      color: "secondary",
                      height: "10",
                      "buffer-value": "0",
                      stream: "",
                      class: "ml-2",
                      "model-value": _ctx.stepData.progressValue
                    }, null, 8, ["model-value"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.showNoDeletedBankTransactionsDialog,
              "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.showNoDeletedBankTransactionsDialog) = $event)),
              title: "Attention",
              validTitle: "Accepter",
              onValid: _cache[56] || (_cache[56] = ($event: any) => {
                    _ctx.showNoDeletedBankTransactionsDialog = false;
                    _ctx.notDeleted.length = 0;
                }),
              width: "800px"
            }, {
              default: _withCtx(() => [
                (_ctx.notDeleted.length === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Le mouvement bancaire n'a pas été éliminé car il est antérieur à la date autorisée. (" + _toDisplayString(_ctx.listOfUnacceptedDates[0].lastDate) + ") ", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.notDeleted.length) + " mouvements bancaires n'ont pas été éliminés car ils sont antérieurs à la date autorisée. ", 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfUnacceptedDates, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item.name) + " (" + _toDisplayString(item.lastDate) + ") ", 1))
                      }), 128))
                    ]))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.showTransactionTypeDialog,
              "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.showTransactionTypeDialog) = $event)),
              title: "Choisissez le type de transaction",
              validTitle: "Valider",
              onValid: _cache[59] || (_cache[59] = ($event: any) => (_ctx.modifyTransactionType())),
              onClose: _cache[60] || (_cache[60] = ($event: any) => (_ctx.closeTransactionTypeDialog())),
              validLoading: _ctx.transactionTypeLoading,
              width: "800px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select_filled, {
                          outlined: "",
                          modelValue: _ctx.transactionType,
                          "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.transactionType) = $event)),
                          items: _ctx.transactionTypes,
                          "item-title": "text",
                          "hide-details": true,
                          density: "compact"
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "validLoading"]),
            (_ctx.editBankTransactionDialog)
              ? (_openBlock(), _createBlock(_component_BankTransactionEdition, {
                  key: 7,
                  modelValue: _ctx.editBankTransactionDialog,
                  "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.editBankTransactionDialog) = $event)),
                  bankTransaction: _ctx.selectedBankTransaction,
                  companyId: _ctx.selectedCompany.id,
                  onUpdated: _cache[62] || (_cache[62] = ($event: any) => (_ctx.refresh()))
                }, null, 8, ["modelValue", "bankTransaction", "companyId"]))
              : _createCommentVNode("", true),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.autoSalesReconciliationDialog,
              "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.autoSalesReconciliationDialog) = $event)),
              title: 'Encaissement',
              actions: _ctx.autoSalesActions,
              width: "800px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AutoSales, {
                  companyId: _ctx.selectedCompany.id,
                  externalValidation: true,
                  actions: _ctx.autoSalesActions,
                  onCreate: _ctx.onAutoSalesCreate,
                  onCancel: _cache[63] || (_cache[63] = ($event: any) => (_ctx.autoSalesReconciliationDialog = false))
                }, null, 8, ["companyId", "actions", "onCreate"])
              ]),
              _: 1
            }, 8, ["modelValue", "actions"]),
            (_ctx.thirdPartyDialog)
              ? (_openBlock(), _createBlock(_component_ThirdPartyCompany, {
                  key: 8,
                  modelValue: _ctx.thirdPartyDialog,
                  "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.thirdPartyDialog) = $event)),
                  companyId: _ctx.selectedCompany.id,
                  companyType: _ctx.companyType,
                  bankTransactions: _ctx.selected,
                  activateFreeTag: true,
                  onAdded: _cache[66] || (_cache[66] = ($event: any) => (_ctx.onThirdPartyAdded()))
                }, null, 8, ["modelValue", "companyId", "companyType", "bankTransactions"]))
              : _createCommentVNode("", true),
            _createVNode(_component_CreateBTChatMessage, {
              active: _ctx.showCreateBankTransactionMessageDialog,
              "onUpdate:active": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.showCreateBankTransactionMessageDialog) = $event)),
              companyId: _ctx.selectedCompany.id,
              bankTransactions: _ctx.selectedBankTransactionsForMessage,
              onMessageCreated: _ctx.refresh
            }, null, 8, ["active", "companyId", "bankTransactions", "onMessageCreated"]),
            (_ctx.bncDocumentDialog)
              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                  key: 9,
                  modelValue: _ctx.bncDocumentDialog,
                  "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.bncDocumentDialog) = $event)),
                  withoutHeader: true,
                  "min-height": "95vh",
                  transition: "dialog-bottom-transition",
                  "min-width": "95vw"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "d-flex justify-center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          style: {"overflow-y":"auto"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_document, {
                              mode: 'Reconciliation',
                              companyId: _ctx.selectedCompany.id,
                              id: _ctx.getLinkedDocumentId(_ctx.selectedBankTransaction),
                              "dark-mode": true,
                              onTaskEnded: _ctx.onDocumentValidated
                            }, null, 8, ["companyId", "id", "onTaskEnded"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (_ctx.documentDialog)
              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                  key: 10,
                  modelValue: _ctx.documentDialog,
                  "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.documentDialog) = $event)),
                  withoutHeader: true,
                  "min-height": "95vh",
                  transition: "dialog-bottom-transition",
                  "min-width": "95vw"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          style: {"overflow-y":"auto"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_document, {
                              mode: 'Reconciliation',
                              companyId: _ctx.selectedCompany.id,
                              id: _ctx.linkedDocumentShown,
                              "dark-mode": true,
                              onTaskEnded: _ctx.onDocumentValidated
                            }, null, 8, ["companyId", "id", "onTaskEnded"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.linkedDocumentsIds.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_component_v_container, {
                                class: "controller",
                                "elevation-1": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn_prev, {
                                    disabled: _ctx.previousDisabled(),
                                    onClick: _cache[69] || (_cache[69] = _withModifiers(($event: any) => (_ctx.previous()), ["stop"]))
                                  }, null, 8, ["disabled"]),
                                  _createVNode(_component_v_btn_next, {
                                    disabled: _ctx.nextDisabled(),
                                    onClick: _cache[70] || (_cache[70] = _withModifiers(($event: any) => (_ctx.next()), ["stop"]))
                                  }, null, 8, ["disabled"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (_ctx.accountableAccountWithSuggestion)
              ? (_openBlock(), _createBlock(_component_AccountableAccountVue, {
                  key: 11,
                  title: "Valider l'affectation",
                  showLabel: true,
                  showValidation: false,
                  needValidation: true,
                  companyId: _ctx.selectedCompany.id,
                  inAccountableAccountType: "Selected",
                  embeddedInput: true,
                  editAccountableAccount: true,
                  defineThirdParty: true,
                  activateFreeTag: true,
                  bankTransactionId: _ctx.selectedBankTransaction.id,
                  startOpenDialog: true,
                  onDialogClosed: _cache[72] || (_cache[72] = ($event: any) => (_ctx.accountableAccountWithSuggestion = false)),
                  onValidated: _cache[73] || (_cache[73] = ($event: any) => (_ctx.setAccountableAccountWithSuggestion($event))),
                  "btn-mode": true
                }, null, 8, ["companyId", "bankTransactionId"]))
              : _createCommentVNode("", true),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.dialogDeletePermanentlySelectedBTs,
              "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.dialogDeletePermanentlySelectedBTs) = $event)),
              title: "Supprimer les flux bancaires selectectionnés définitivement",
              onValid: _cache[75] || (_cache[75] = ($event: any) => (_ctx.deleteBankTransactions(true))),
              width: "800px"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("h4", null, " Voulez-vous supprimer définitivement " + _toDisplayString(_ctx.selected.length) + " flux bancaire" + _toDisplayString(_ctx.selected.length === 1 ? "" : "s") + " ? ", 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}